import React, { useState, useEffect } from 'react';
import VaccinationTable from '../Body/VaccinationTable';
import vaccinationService from '../services/vaccinationService';
import DoctorManagementMenu from "../../../components/common/Menu/DoctorManagement";
import TopHeader from "../../../components/common/Header/TopHeader";

const VaccinationList = () => {
    const [vaccinations, setVaccinations] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const handleDeleteVaccinations = async (vaccinationsToDelete) => {
        try {
            if (Array.isArray(vaccinationsToDelete)) {
                // Eliminar múltiples vacunaciones
                for (const vaccination of vaccinationsToDelete) {
                    await vaccinationService.deleteVaccination(vaccination._id);
                }
                // Actualizar el estado local después de eliminar todas
                const idsToDelete = vaccinationsToDelete.map(v => v._id);
                setVaccinations(prev => prev.filter(v => !idsToDelete.includes(v._id)));
            } else {
                // Eliminar una sola vacunación
                await vaccinationService.deleteVaccination(vaccinationsToDelete.id);
                // Actualizar el estado local
                setVaccinations(prev => prev.filter(v => v._id !== vaccinationsToDelete.id));
            }
        } catch (error) {
            console.error('Error deleting vaccination(s):', error);
            // Aquí podrías mostrar un mensaje de error al usuario
        }
    };

    // Fetch vaccinations from API when component mounts
    useEffect(() => {
        fetchVaccinations();
    }, []);

    // function to fetch vaccinations from the API
    const fetchVaccinations = async () => {
        try {
            setIsLoading(true);
            const response = await vaccinationService.getAllVaccinations();
            
            if (response.status) {
                // Process vaccinations to handle potential null fields
                const processedVaccinations = response.data.map(vaccination => {
                    return {
                        ...vaccination,
                        doctor: vaccination.doctor || { _id: 'unknown' },
                        patient: vaccination.patient || { _id: 'unknown' }
                    };
                });
                
                setVaccinations(processedVaccinations);
                setError(null);
            } else {
                setError('Error al obtener vacunaciones: ' + (response.message || 'Error desconocido'));
            }
        } catch (error) {
            console.error('Error fetching vaccinations:', error);
            setError('Error al cargar las vacunaciones. Por favor, inténtelo de nuevo más tarde.');
        } finally {
            setIsLoading(false);
        }
    };
        
    return (
        <main id="app">
            <TopHeader />
            <div className="content_wrapper">
            <div class="doctor-management-wrapper bg-white pb-5">
                {/* <NavigationClinicalMagnament/> */}
                <DoctorManagementMenu activeMenu='/vaccinations'/>
                {/* <NavigationMenu /> */}
                
                                               
                            <section>
                                <VaccinationTable
                                    vaccinations={vaccinations}
                                    onDeleteVaccinations={handleDeleteVaccinations}
                                />
                            </section>
                        
                    
                </div>
            </div>
        </main>
    );
};

export default VaccinationList;